import { SplitedTextProps } from '@/models/Headings';

import SplitedText from './SplitedText';

export default function SectionTitle(props: SplitedTextProps) {
  const { text, anchor, init, fontWeight, offset, stroke, align } = props;

  return (
    <>
      <span className='hidden' dangerouslySetInnerHTML={{ __html: text }} />
      <SplitedText
        text={text}
        anchor={anchor}
        offset={offset}
        init={init}
        stroke={stroke}
        align={align}
        fontWeight={fontWeight}
      />
    </>
  );
}
